export default __webpack_public_path__ + "b11b6ebef44d7da28317a071fc1d1979.png";